module.exports = __webpack_public_path__ + "img/alert.84a45df0.gif";